import { createSelector } from 'reselect'
import { SettingsRootState } from '../root.reducer'

export const getMembers = createSelector(
  (state: SettingsRootState) => state.dataStore.member,
  (state) => state,
)

export const getEvents = createSelector(
  (state: SettingsRootState) => state.dataStore.events,
  (state) => state,
)

export const getEventPriceCategories = createSelector(
  (state: SettingsRootState) => state.dataStore.eventPriceCategories,
  (state) => state,
)

export const getEventMember = createSelector(
  (state: SettingsRootState) => state.dataStore.eventMember,
  (state) => state,
)

export const getEventLocations = createSelector(
  (state: SettingsRootState) => state.dataStore.eventLocations,
  (state) => state,
)

export const getEventResults = createSelector(
  (state: SettingsRootState) => state.dataStore.eventResults,
  (state) => state,
)

export const getRelations = createSelector(
  (state: SettingsRootState) => state.dataStore.relations,
  (state) => state,
)

export const getStatistics = createSelector(
  (state: SettingsRootState) => state.dataStore.statistics,
  (state) => state,
)
